import { connect } from 'react-redux';

// types
import { State } from 'widgets/friends-referral/root/root.reducers';
// components
import SoftClosingBlock from './soft-closing-block.component';
// types
import { ISoftClosingBlockStoreProps } from './soft-closing-block.types';

const mapStateToProps = (state: State): ISoftClosingBlockStoreProps => ({
    endDate: state.friendsReferral.campaignInfo.endDate,
    currentView: state.router.currentView || '',
    shouldInheritStyles: state.config.shouldInheritStyles
});

export default connect(mapStateToProps)(SoftClosingBlock);
